import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { money } from "@/components/common";
import { ReferralBanner } from "@/components/ReferralBanner";

const MAX_TRIES = 8;

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const [state, setState] = useState("checking"); // checking | paid | timeout | error
  const [order, setOrder] = useState(null);
  const tries = useRef(0);

  useEffect(() => {
    const sessionId = new URLSearchParams(window.location.search).get("session_id");
    if (!sessionId) { setState("error"); return; }
    let stop = false;
    const poll = async () => {
      if (stop) return;
      if (tries.current >= MAX_TRIES) { setState("timeout"); return; }
      tries.current += 1;
      try {
        const s = await api.get(`/payments/status/${sessionId}`);
        if (s.payment_status === "paid") { setOrder(s); setState("paid"); return; }
        if (s.status === "expired") { setState("error"); return; }
      } catch { /* retry */ }
      setTimeout(poll, 1800);
    };
    poll();
    return () => { stop = true; };
  }, []);

  return (
    <div className="auth-wrap">
      <div className="auth-card fade-up" style={{ textAlign: "center" }} data-testid="payment-success">
        {state === "checking" && (<><Loader2 size={46} className="spin" style={{ color: "var(--brand)" }} /><h1 style={{ fontSize: 24, marginTop: 14 }}>Confirming your payment…</h1><p className="ss-muted">Hang tight, this only takes a moment.</p></>)}
        {state === "paid" && (<>
          <CheckCircle2 size={54} style={{ color: "var(--success)" }} />
          <h1 style={{ fontSize: 26, marginTop: 12 }}>Payment successful!</h1>
          <p className="ss-muted" style={{ marginTop: 6 }}>{order?.item_title} · {money(order?.amount)}</p>
          <div style={{ display: "flex", gap: 10, justifyContent: "center", marginTop: 22 }}>
            <button className="ss-btn ss-btn-primary" onClick={() => navigate("/purchases")} data-testid="go-purchases">View my purchases</button>
            <button className="ss-btn ss-btn-ghost" onClick={() => navigate("/")}>Keep shopping</button>
          </div>
          <div style={{ marginTop: 22 }}>
            <ReferralBanner headline="Loved it? Refer a friend & win this month's prize" style={{ textAlign: "left" }} />
          </div>
        </>)}
        {(state === "timeout" || state === "error") && (<>
          <XCircle size={50} style={{ color: "var(--warning)" }} />
          <h1 style={{ fontSize: 24, marginTop: 12 }}>We couldn't confirm yet</h1>
          <p className="ss-muted" style={{ marginTop: 6 }}>If you completed payment, it will appear in Purchases shortly.</p>
          <button className="ss-btn ss-btn-primary" style={{ marginTop: 18 }} onClick={() => navigate("/purchases")}>Go to Purchases</button>
        </>)}
      </div>
    </div>
  );
}
